import React, {Component} from 'react'
import { connect } from 'react-redux';

import RoomClosePopup from '../RoomClosePopup/index';
import RoomPasswordPopup from '../RoomPasswordPopup/index';

import Registry from '../../../registry/index';

import {
    ROOM_TYPE_PERMANENT,
    ROOM_TYPE_VIRTUAL,
    VISIBLE_ROOM_SWITCHED
} from '../../../constants/rooms';

class RoomListItem extends Component {
    constructor(props) {
        super(props);

        this.login = this.login.bind(this);
        this.close = this.close.bind(this);
        this.touchAction = this.touchAction.bind(this);
        this.loginSuccess = this.loginSuccess.bind(this);
    }

    componentDidMount() {
        window.addEventListener('touchstart', this.touchAction, false);
    }

    touchAction(event) {
        let { tooltipClose } = this.props;

        tooltipClose();
    }

    joinRoom(event) {
        event.preventDefault();
        let {room, currentUser, dispatch, onRoomChangedMobile, notificationsWindow, pmWindow } = this.props;
        
        // if (room.stayed) {
        //     return false;
        // }

        if (room.visible && !notificationsWindow && !pmWindow) {
            return false;
        }

        let chatInterface = Registry.get('chatInterface');

        if (room.info.open || room.info.creator === currentUser.uid) {
            dispatch({type: VISIBLE_ROOM_SWITCHED, room: this.props.room});
            onRoomChangedMobile();

            chatInterface.joinRoom(
                room.roomid,
                '',
                function() {
                    //dispatch({type: TEMPORAL_ROOM_JOINED, room: this.props.room})
                },
                function() {}
            )
        } else {
            RoomPasswordPopup.open({
                room: this.props.room,
                dispatch: this.props.dispatch
            });
        }
    }
    
    leaveRoom(event) {
        event.preventDefault();
        
        let {room} = this.props;

        if (!room.active) {
            this.leaveSuccess();
            return false;
        }

        let chatInterface = Registry.get('chatInterface');

        chatInterface.leaveRoom(
            room.roomid,
            this.leaveSuccess,
            function() {})
    }


    login(event) {
        event.preventDefault();

        this.props.dispatch({type: VISIBLE_ROOM_SWITCHED, room: this.props.room});
        
        return;


        let {room, currentUser, currentRoom} = this.props;


        if (room.roomid === currentRoom.id) {
            this.loginSuccess();
            return false;
        }

        let chatInterface = Registry.get('chatInterface');

        if (room.open || room.creator === currentUser.uid) {
            chatInterface.joinRoom(
                room.roomid,
                '',
                this.loginSuccess,
                function() {}
            )
        } else {
            RoomPasswordPopup.open({
                room: this.props.room
            });
        }
    }

    close() {
        RoomClosePopup.open({
            room: this.props.room
        });
    }

    loginSuccess() {
        let {onRoomChangedMobile} = this.props;

        onRoomChangedMobile();
    }

    render() {
        let lang = Registry.get('locale');

        let {room, mainRoomId, hoverFn, browser} = this.props;
        let cssClasses = [];

        let isMain = (room.roomid === mainRoomId);
        let isCurrent = room.active;
        let hasUnreadMessages = room.unreadMessages;
        let isPermanent = room.info.type === ROOM_TYPE_PERMANENT;
        let isVirtual = room.info.type === ROOM_TYPE_VIRTUAL;
        let isVisible = this.props.visible;
        let isJoined = room.stayed;

        let displayName = room.info.name || room.roomid;

        if (isMain) cssClasses.push("main");
        if (isPermanent) cssClasses.push("permanent");
        if (isVirtual) cssClasses.push("virtual");
        if (isCurrent) cssClasses.push("current");
        if (isJoined) cssClasses.push("joined");
        if (isVisible) cssClasses.push("visible");

        if (hasUnreadMessages) cssClasses.push('focus');

        if (!room.info.open) cssClasses.push("locked");

        let userCount = room.info.users;
        if (isCurrent && room.users.size) userCount = room.users.size;

        return (
            <li
                className={'room '+cssClasses.join(' ')} 
                data-roomid={room.roomid} 
                onMouseEnter={(event) => browser.desktop ? hoverFn(event, room.info) : false} 
                onMouseLeave={(event) => hoverFn(event, room.info)}>
                <i onClick={this.joinRoom.bind(this)}>
                    <span className="room-name">
                        {displayName}
                    </span>
                    <span className="count">{userCount}</span>
                </i>
                {room.info.editable && <a className="close" onClick={this.close}>&times;</a>}
                {!isPermanent && !browser.desktop ? <a className="icon-info" onClick={(event) => hoverFn(event, room.info)} /> : false}
            </li>);
    }
}

//export default RoomListItem;
export default connect()(RoomListItem);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomListItem/index.js